module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "contactDebtorList"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Creditors list"
    }
  }), _vm._v(" "), _c('f7-tabs', [_c('f7-tab', {
    staticClass: "requestContactTab1",
    attrs: {
      "active": ""
    }
  }, [_c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contact-debtors-list",
      "placeholder": "Search in Creditors"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    attrs: {
      "id": "contact-debtors-list",
      "contacts": ""
    }
  }, _vm._l((this.contactSelectionList), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        on: {
          "change": function($event) {
            return _vm.changeItem()
          }
        }
      }, [_c('label', {
        staticClass: "label-checkbox item-content boxRequest"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.contactDebtors),
          expression: "contactDebtors"
        }],
        staticClass: "inputContact",
        attrs: {
          "type": "checkbox",
          "name": "contactDebtorCheckbox"
        },
        domProps: {
          "value": contact.id,
          "checked": Array.isArray(_vm.contactDebtors) ? _vm._i(_vm.contactDebtors, contact.id) > -1 : (_vm.contactDebtors)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.contactDebtors,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = contact.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.contactDebtors = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.contactDebtors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.contactDebtors = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media"
      }, [_c('i', {
        staticClass: "icon icon-form-checkbox"
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))])])])])
    })], 2)
  }), 1)], 1)], 1), _vm._v(" "), _c('f7-tab', {
    staticClass: "requestContactTab2"
  }, [_c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contact-debtors-list",
      "placeholder": "Search in Groups"
    }
  }), _vm._v(" "), _c('f7-list', _vm._l((_vm.contactGroups), function(contactGroup, index) {
    return _c('li', {
      on: {
        "change": function($event) {
          return _vm.changeGroupItem()
        }
      }
    }, [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contactGroupsSelected),
        expression: "contactGroupsSelected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "contactGroupCheckbox"
      },
      domProps: {
        "value": contactGroup.id,
        "checked": Array.isArray(_vm.contactGroupsSelected) ? _vm._i(_vm.contactGroupsSelected, contactGroup.id) > -1 : (_vm.contactGroupsSelected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.contactGroupsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = contactGroup.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.contactGroupsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.contactGroupsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.contactGroupsSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(contactGroup.label))])])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "webdatalist row",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('f7-button', {
    staticClass: "orangeConfirmationButton button-inner-color",
    attrs: {
      "round": "",
      "title": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('f7-link', {}, [_vm._v(" Cancel")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-3"
  }, [_c('f7-button', {
    staticClass: "orangeConfirmationButton button-inner-color",
    attrs: {
      "round": "",
      "title": "Add Contact"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('f7-link', {}, [_vm._v("Add contact")])], 1)], 1)])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ead6116", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ead6116","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/payments/CMContactDebtorList.vue
// module id = 1679
// module chunks = 2